module.exports = __webpack_public_path__ + "media/images/new/mobile/icons/app_apple-9742904c410cc0f8b6db0375fc6c7ea6.png";